import { ComponentProps } from 'react';
import { PaginatorWithDescription } from '@edu-frontend/modules/src/shared/ui/PaginatorWithDescription';
import { Page } from '../../../paginator/types';

export const checkPagesType = (
    pages: ComponentProps<typeof PaginatorWithDescription>['pages'] | Page[]
): pages is Page[] => {
    return 'selected' in pages[0];
};
